import type * as mdast from 'mdast';
import type { Handle } from 'mdast-util-to-markdown';

/**
 * A compiler for any markdown elements to wrap liquid tags with {% raw %} when
 * necessary.
 */
export function compileLiquidTags(handler: Handle): Handle {
    return (node: mdast.Code, parent, context, safeOptions) =>
        unescapeLiquidTags(handler(node, parent, context, safeOptions));
}

/**
 * Unescapes any liquid tags in the text by removing the backslashes `\` from the brackets. Will only work with
 * strings escaped with `escapeLiquidTags`.
 */
export function unescapeLiquidTags(content: string): string {
    return content
        .replace(/\\{% /g, '{% ')
        .replace(/ %\\}/g, ' %}')
        .replace(/\\{{ /g, '{{ ')
        .replace(/ \\}}/g, ' }}');
}
